export default __webpack_public_path__ + "static/media/Logo_Cappy_Freefalling.4bb4430e.png";